<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>{{title}}</h1>
            <!-- <ul>
                <li><a href="index.html">home</a></li>
                <li>&gt;</li>
                <li> Dashboard</li>
            </ul> -->
        </div>
    </div>
</div>

<section class="dashboard-box py-12 px-4 text-center">
    <div class="container">
        <div class="col-md-12">
            <div class="row">
                <div class="dashboard-banner-box">
                    <img src="../assets/images/all-instructor/dashboard-msg-icon.png" class="el-star-smile" alt="">
                    <div class="box-parent">
                        <div class="col-md-4 d-none d-md-none d-lg-block d-xl-block">
                            <div class="el-banner-right" style="width: 300px;">
                                <div class="el-banner-img ">
                                    <img src="assets/images/all-instructor/dash-boy.png" alt="banner boy"
                                        style="width: 280px;">
                                </div>

                                <div class="banner-img-bg-circle" id="banner-img-bg-circle">
                                    <img src="assets/images/all-instructor/banner-img-bg-circle.png"
                                        alt="banner-img-bg-circle" class="img-fluid">
                                </div>
                                <div class="banner-img-bg-circle2" id="banner-img-bg-circle2">
                                    <img src="assets/images/all-instructor/banner-img-bg-circle.png"
                                        alt="banner-img-bg-circle2" class="img-fluid">
                                </div>
                            </div>

                        </div>
                        <div class="col-md-12 col-lg-8 col-xl-8">
                            <div class="row">
                                <div class="box-content-1">
                                    <div class="col-md-6 text-start">
                                        <img src="../assets/images/all-instructor/book-con-dasboard.png"
                                            class="el-arrow1" alt="">
                                        <h1>Free <span>Mock Test</span></h1>
                                        <h3>Real-time Practice designed to mirror the actual Olympiad experience.

                                        </h3>

                                    </div>
                                    <div class="col-md-6">

                                        <div class="mt-0 col"><a class="el-btn" [routerLink]="['/freemock']"> Start Mock
                                                test</a></div>


                                    </div>
                                </div>
                            </div>
                            <img src="../assets/images/all-instructor/dasboard-pencel.png" alt="" class="pencel ">

                        </div>
                    </div>

                </div>
            </div>
        </div>




    </div>

</section>